import Model from '@/models/Model'
export default class SlCustomer extends Model {
    resource() {
        return 'sl_check'
    }

    retireCheck(idCheck) {
        return new Promise((resolve, reject) => {
            const url =
                process.env.VUE_APP_API_ROUTE +
                '/' +
                this.resource() +
                '/' +
                idCheck +
                '/retire'

            this.$http
                .post(url)
                .then(function (response) {
                    console.log(response);
                    resolve(response)
                  })
                  .catch(function (error) {
                    console.log(error);
                    resolve(reject)
                  })
        })
    }
}
